/**
 *
 * All the reducer will exports from here,
 *
 */

import { combineReducers } from 'redux';
import { AdminReducer } from './AdminReducer';
import { AuthReducer } from './AuthReducer';
import { ImageUploaderReducer } from './ImageUploaderReducer';
// import { JsConfigReducer } from './JsConfigReducers';
import { UpdatePageHeaderReducer } from './PageHeader';
import { OPReportingReducer } from './OPReportingReducer';
import { RetargetingConfigReducer } from './RetargetingConfigReducer';
import { RolesReducer } from './RolesReduces';
import { TagGeneratorReducer } from './TagGeneratorReducer';
import { ToastReducer } from './ToastReducer';
import { DomainReducer } from './DomainReducer';
import { CampaignsReducer } from './CampaignsReducer';
import { CTargetingReducer } from './CtargetingReducer';
import { EventsLoggerReducer } from './EventsLoggerReducer';
import { AdsImpressionsReducer } from './AdsImpressionsReducer';
import { ClineItemsReducer } from './ClineItemsReducer';
import { ClineItemsDemoReducer } from './ClineItemDemoReducer';
import { OPCreativeUploadReducer } from './OPCreativeUploadReducer';
import GLUReducers from './GLUReducers';
import { HtmlbannerReducer } from './HtmlbannerReducer';
import { ReportsReducer } from './ReportsReducer';
import { BidRequestsReducer } from './BidRequestsReducer';
import { RealtimeMonitorReducer } from './RealtimeMonitorReducer';
import { UserManagementReducer } from './UserManagementReducer'
import { CreativeUploadReducer } from './CreativeUploadReducer';
import { UserInfoReducer } from './UserInfoReducer';
import { UserInfoV2Reducer } from './UserInfoV2Reducer';
import { AdsDashboardReducer } from './AdsDashboardReducer';
import { YandexReducer } from './YandexReducer';
import { HashReducer } from './HashReducer';
import {UserInfoNGReducer} from './UserInfoNGReducer';

const rootReducer = combineReducers({
  Auth: AuthReducer,
  Toast: ToastReducer,
  PageHeader: UpdatePageHeaderReducer,
  TagGenerator: TagGeneratorReducer,
  ImageUploader: ImageUploaderReducer,
  OPReporting: OPReportingReducer,
  TargetingConfig: RetargetingConfigReducer,
  Admin: AdminReducer,
  Roles: RolesReducer,
  // JsConfig: JsConfigReducer,
  Campaigns: CampaignsReducer,
  Domain: DomainReducer,
  CTargeting:CTargetingReducer,
  EventsLogger:EventsLoggerReducer,
  AdsImpressions:AdsImpressionsReducer,
  ClineItem:ClineItemsReducer,
  ClineItemDemo:ClineItemsDemoReducer,
  OPCreativeUpload:OPCreativeUploadReducer,
  CreativeUpload:CreativeUploadReducer,
  GLUReducers: GLUReducers,
  HtmlbannerReducer:HtmlbannerReducer,
  Reports:ReportsReducer,
  BidRequests:BidRequestsReducer,
  RealtimeMonitor:RealtimeMonitorReducer,
  UserManagement: UserManagementReducer,
  UserInfo:UserInfoReducer,
  UserInfoV2: UserInfoV2Reducer,
  UserInfoNG: UserInfoNGReducer,
  AdsDashboard: AdsDashboardReducer,
  Yandex: YandexReducer,
  Hash: HashReducer
});

export default rootReducer;